// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gem{height:160px;width:100%;list-style:none;position:relative}.gem img{height:65%;padding:0 20px;margin:0;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.Wildlife .gem img{height:auto;width:80%}", ""]);
// Exports
module.exports = exports;
